module.exports = __webpack_public_path__ + "img/algebra.434ed1e9.jpeg";